import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";
import { LEGAL } from "@/constants/legal";

export default function Termini() {
  return (
    <LegalLayout overline="Termini e condizioni" title="Termini di Vendita">
      <p className="lead">
        I presenti termini disciplinano la vendita del libro{" "}
        <em>"{LEGAL.bookTitle}"</em> tramite il sito{" "}
        <a href={LEGAL.siteUrl}>{LEGAL.siteUrl}</a>, ai sensi del Codice del
        Consumo (D.Lgs. 206/2005) e del D.Lgs. 70/2003 in materia di commercio
        elettronico.
      </p>

      <h2>1. Venditore</h2>
      <p>
        <strong>{LEGAL.ownerName}</strong>
        <br />
        {LEGAL.address}
        <br />
        Codice Fiscale: {LEGAL.fiscalCode}
        <br />
        Email: <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>
        <br />
        WhatsApp: {LEGAL.whatsapp}
      </p>

      <h2>2. Oggetto del contratto</h2>
      <p>
        Il presente contratto ha per oggetto la vendita del libro{" "}
        <em>"{LEGAL.bookTitle}"</em> di Michele Roccaro (ISBN{" "}
        {LEGAL.bookIsbn}), nelle edizioni Paperback (€19,90) e Kindle (€7,90)
        disponibili su Amazon Italia.
      </p>
      <p>
        Per acquisti tramite il bottone "Acquista su Amazon" il contratto di
        vendita è concluso con Amazon EU S.à.r.l. e disciplinato dalle{" "}
        <a
          href="https://www.amazon.it/gp/help/customer/display.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          condizioni d'uso di Amazon
        </a>
        .
      </p>
      <p>
        Per acquisti tramite il bottone "Paga con carta · Apple Pay · Google
        Pay" il pagamento è gestito da <strong>Stripe Payments Europe
        Limited</strong> e il contratto è concluso direttamente con il
        Venditore.
      </p>

      <h2>3. Prezzi e modalità di pagamento</h2>
      <p>
        I prezzi sono espressi in Euro (€), IVA inclusa ove applicabile. Sono
        accettate le seguenti modalità di pagamento:
      </p>
      <ul>
        <li>Carte di credito/debito (Visa, Mastercard, American Express)</li>
        <li>Apple Pay</li>
        <li>Google Pay</li>
        <li>Per acquisto via Amazon: tutti i metodi di pagamento accettati dalla piattaforma</li>
      </ul>

      <h2>4. Spedizione e consegna</h2>
      <p>
        Le spedizioni per il formato cartaceo sono gestite da Amazon Logistica
        per gli acquisti tramite Amazon. Tempi di consegna stimati: 3-5 giorni
        lavorativi per l'Italia tramite corriere tracciato. Eventuali
        spedizioni dirette gestite dal Venditore avvengono entro 7 giorni
        lavorativi dalla conferma del pagamento.
      </p>

      <h2>5. Diritto di recesso</h2>
      <p>
        Ai sensi degli artt. 52 e seguenti del D.Lgs. 206/2005 (Codice del
        Consumo), il consumatore ha diritto di recedere dal contratto entro{" "}
        <strong>14 giorni</strong> dalla consegna del bene, senza fornire
        alcuna motivazione.
      </p>
      <p>
        Per esercitare il diritto di recesso il consumatore deve informare il
        Venditore mediante dichiarazione esplicita inviata all'indirizzo email{" "}
        <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>, indicando il
        numero d'ordine e i propri recapiti.
      </p>
      <p>
        Per acquisti effettuati tramite Amazon il diritto di recesso è regolato
        dalle condizioni Amazon (in genere 14-30 giorni).
      </p>
      <p>
        <strong>Esclusioni:</strong> il diritto di recesso non si applica alla
        fornitura di contenuti digitali (Kindle) dopo che l'esecuzione è
        iniziata con l'accordo espresso del consumatore (Art. 59 lett. o,
        D.Lgs. 206/2005).
      </p>

      <h2>6. Rimborso</h2>
      <p>
        In caso di recesso, il Venditore rimborserà il prezzo pagato entro 14
        giorni dalla ricezione del bene reso, utilizzando lo stesso metodo di
        pagamento usato per l'acquisto. Le spese di restituzione sono a carico
        del consumatore, salvo diversa disposizione di legge.
      </p>

      <h2>7. Garanzia legale di conformità</h2>
      <p>
        Tutti i prodotti venduti sono coperti dalla garanzia legale di
        conformità di 24 mesi prevista dagli artt. 128-135 del Codice del
        Consumo. La garanzia copre eventuali difetti di conformità presenti al
        momento della consegna.
      </p>

      <h2>8. Limitazione di responsabilità</h2>
      <p>
        Il contenuto del libro <em>"{LEGAL.bookTitle}"</em> ha finalità
        informativa, formativa e divulgativa. Non costituisce consulenza
        professionale, legale, fiscale o finanziaria personalizzata. L'autore e
        il Venditore non sono responsabili dei risultati derivanti
        dall'applicazione dei contenuti del libro.
      </p>

      <h2>9. Proprietà intellettuale</h2>
      <p>
        Tutti i contenuti del libro, del sito e dell'audiolibro (testi,
        immagini, audio, grafica) sono di proprietà di {LEGAL.ownerName} e
        protetti dalle leggi sul diritto d'autore (L. 633/1941). È vietata la
        riproduzione, distribuzione o modifica senza autorizzazione scritta.
      </p>

      <h2>10. Risoluzione delle controversie — ODR</h2>
      <p>
        Ai sensi del Regolamento UE 524/2013, in caso di controversia il
        consumatore può ricorrere alla piattaforma di Online Dispute Resolution
        della Commissione Europea, disponibile all'indirizzo:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
        >
          ec.europa.eu/consumers/odr
        </a>
        .
      </p>

      <h2>11. Legge applicabile e foro competente</h2>
      <p>
        Il presente contratto è regolato dalla legge italiana. Per qualsiasi
        controversia è competente il Foro del luogo di residenza o domicilio
        del consumatore, se ubicato in Italia (Art. 66-bis Codice del Consumo).
        In tutti gli altri casi, il Foro di Ragusa.
      </p>

      <h2>12. Modifiche ai termini</h2>
      <p>
        Il Venditore si riserva il diritto di modificare i presenti Termini in
        qualsiasi momento. Le modifiche saranno efficaci dalla data di
        pubblicazione sul sito.
      </p>

      <p className="mt-12 text-sm text-[#3A4F6B]">
        Ultimo aggiornamento: {LEGAL.lastUpdated}.
      </p>
    </LegalLayout>
  );
}
